import React, { useEffect, useState, useMemo } from 'react';
import Container from '../../../Container/Container';
import { get, ImageUrl, post } from '../../../ApiServices/ApiServices';
import { useNavigate, useLocation, Link, useParams } from 'react-router';
import { useForm, Controller } from "react-hook-form";
import Select from 'react-select';
import { Image } from 'antd';
import moment from 'moment';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import Loader from '../../Component/Loader';
import { BrideLogoIcon, GroomLogoIcon } from '../../Component/Svg';

function Addmember() {
    const [data, setdata] = useState([]);
    const [coatStyle, setCoatstyle] = useState(null);
    const [pantStyle, setPantstyle] = useState(null);
    const [shirtStyle, setShirtstyle] = useState(null);
    const [vestStyle, setVeststyle] = useState(null);
    const [tieStyle, setTiestyle] = useState(null);
    const [shoeStyle, setShoestyle] = useState(null);
    const [pocketStyle, setPocketstyle] = useState(null);
    const [jewelryStyle, setJewelrystyle] = useState(null);
    const [Gettype, setGettype] = useState([]);
    const [AllData, setAllData] = useState([])
    const [CopyStyle, setCopyStyle] = useState([]);
    const [loading, setLoading] = useState(true);
    // const { eventid } = useParams(); // ✅ Get eventId from URL
    const [isSubmitting, setIsSubmitting] = useState(false);
    const location = useLocation()
    const [selectedCopyStyle, setSelectedCopyStyle] = useState(null);
    const { eventid, Account, user_Id, } = location.state || {};

    const profile = useSelector((state) => state.profile.profile);
    console.log(profile, "profile")

    const navigate = useNavigate();
    // const { Alldata } = location.state || {};
    const [Alldata, setAlldata] = useState(null)
    console.log(Alldata, "Alldata")
    const [activeItem, setActiveItem] = useState(1);

    console.log(Account, "Account", user_Id, "user_Id")



    const toggleItem = (id) => {
        setActiveItem(activeItem === id ? null : id);
    };


    const AccordionItem = ({ id, title, selectedStyle, children }) => {
        const [isHovered, setIsHovered] = useState(false);
        const isActive = activeItem === id;
        const displayTitle = selectedStyle && !isActive
            ? `${title} - ${selectedStyle}`
            : title;
        return (
            <div className="accordion-item">
                <button
                    className={`accordion-button ${isActive ? 'active' : ''}`}
                    onClick={() => toggleItem(id)}
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                >
                    {/* <span>{title}</span> */}
                    <span>{displayTitle}</span>
                    <span className="accordion-icon">{isActive ? <em class="icon ni ni-upword-ios"></em> : <em class="icon ni ni-downward-ios"></em>}</span>
                </button>
                {isActive && <div className="accordion-content">{children}</div>}
            </div>
        );
    };



    const getWeddingDetail = async () => {
        try {
            const api = `view-wedding-event/${eventid}`;
            const response = await get(api);
            if (response?.status === true) {
                setAlldata(response.data);
            }
        } catch (err) {
            console.error('Error fetching wedding orders:', err);
        } finally {
        }
    };

    useEffect(() => {
        if (eventid) {
            getWeddingDetail();

        } else {
            navigate('/weddings'); // ✅ Redirect if no eventId
        }
    }, [eventid]);



    const getGroomStyles = () => {
        if (!Alldata?.wedding_style) return [];
        return Alldata.wedding_style.filter(style => style.type === 'groom');
    };
    const getGroomsmenStyles = () => {
        if (!Alldata?.wedding_style) return [];
        return Alldata.wedding_style.filter(style => style.type === 'groomsman');
    };
    const getStyleAndDescription = (styles, category) => {
        const item = styles.find(s => s.inventory_category_type === category &&
            s.inventory_category?.inventories?.[0]);

        if (!item) return 'N/A';

        const inventory = item.inventory_category.inventories[0];
        const style = item.style;
        const description = inventory.description;

        return description ? `${style} - ${description}` : style;
    };
    const groomStyles = getGroomStyles();
    // {}
    const groomcoatItems = groomStyles?.filter(item => item.inventory_category_type === 'Coats') || [];

    const groomsmenStyles = getGroomsmenStyles();

    console.log(getGroomsmenStyles, "groomsmenStyles")
    const coatItems = AllData?.wedding_style?.filter(item => item.inventory_category_type === 'Coats') || [];
    const Pants = AllData?.wedding_style?.filter(item => item.inventory_category_type === 'Pants') || [];
    const Shirt = AllData?.wedding_style?.filter(item => item.inventory_category_type === 'Shirt') || [];
    const Vests = AllData?.wedding_style?.filter(item => item.inventory_category_type === 'Vests') || [];
    const Ties = AllData?.wedding_style?.filter(item => item.inventory_category_type === 'Ties') || [];
    const PocketSquare = AllData?.wedding_style?.filter(item => item.inventory_category_type === 'PocketSquare') || [];
    const Jewellery = AllData?.wedding_style?.filter(item => item.inventory_category_type === 'Jewellery') || [];
    const Shoes = AllData?.wedding_style?.filter(item => item.inventory_category_type === 'Shoes') || [];


    const coatItemsdata = coatItems[0]?.inventory || []
    const Pantssdata = Pants[0]?.inventory || []
    const Shirtdata = Shirt[0]?.inventory || []
    const Vestsdata = Vests[0]?.inventory || []
    const Tiesdata = Ties[0]?.inventory || []
    const PocketSquaredata = PocketSquare[0]?.inventory || []
    const Jewellerydata = Jewellery[0]?.inventory || []
    const Shoesdata = Shoes[0]?.inventory || []

    const category1Data = data?.filter((item) => item.category_id === 1);
    const pants = data?.filter((item) => item.category_id === 2);
    const shirts = data?.filter((item) => item.category_id === 3);
    const vests = data?.filter((item) => item.category_id === 4);
    const ties = data?.filter((item) => item.category_id === 5);
    const shoes = data?.filter((item) => item.category_id === 7);
    const pockets = data?.filter((item) => item.category_id === 8);
    const jewelries = data?.filter((item) => item.category_id === 9);

    useEffect(() => {

        // Check if rental items differ from inventory
        const subRentalCoat = category1Data && category1Data?.some(option => option.style == coatItemsdata?.style);
        const subRentalPants = pants && pants?.some(option => option.style == Pantssdata?.style);
        const subRentalShirts = shirts && shirts?.some(option => option.style == Shirtdata?.style);
        const subRentalVests = vests && vests?.some(option => option.style == Vestsdata?.style);
        const subRentalTies = ties && ties?.some(option => option.style == Tiesdata?.style);
        const subRentalShoes = shoes && shoes?.some(option => option.style == Shoesdata?.style);
        const subRentalPockets = pockets && pockets?.some(option => option.style == PocketSquaredata?.style);
        const subRentalJewelries = jewelries && jewelries?.some(option => option.style == Jewellerydata?.style);

        // Set values for style fields only if rental differs
        if (subRentalCoat && coatItemsdata) {
            setValue('GroomMenCoat', coatItemsdata?.style || '');
            setValue('GroomMencoatinventory_id', coatItemsdata?.id || null);
            setCoatstyle(coatItemsdata || null)

        }

        if (subRentalPants && Pantssdata) {
            setValue('GroomMenPant', Pantssdata?.style || '');
            setValue('GroomMenPaintinventory_id', Pantssdata?.id || null);
            setPantstyle(Pantssdata || null)

        }

        if (subRentalShirts && Shirtdata) {
            setValue('GroomMenShirt', Shirtdata?.style || '');
            setValue('GroomMenshirtinventory_id', Shirtdata?.id || null);
            setShirtstyle(Shirtdata || null)

        }

        if (subRentalVests && Vestsdata) {
            setValue('GroomMenVest', Vestsdata?.style || '');
            setValue('GroomMenvestinventory_id', Vestsdata?.id || null);
            setVeststyle(Vestsdata || null)

        }

        if (subRentalTies && Tiesdata) {
            setValue('GroomMenTie', Tiesdata?.style || '');
            setValue('GroomMentietinventory_id', Tiesdata?.id || null);
            setTiestyle(Tiesdata || null)

        }

        if (subRentalShoes && Shoesdata) {
            setValue('GroomMenShoe', Shoesdata?.style || '');
            setValue('GroomMenshoeinventory_id', Shoesdata?.id || null);
            setShoestyle(Shoesdata || null)

        }

        if (subRentalPockets && PocketSquaredata) {
            setValue('GroomMenPocket', PocketSquaredata?.style || '');
            setValue('GroomMenpocketinventory_id', PocketSquaredata?.id || null);
            setPocketstyle(PocketSquaredata || null)

        }

        if (subRentalJewelries && Jewellerydata) {
            setValue('GroomMenJewelry', Jewellerydata?.style || '');
            setValue('GroomMenjewelryinventory_id', Jewellerydata?.id || null);
            setJewelrystyle(Jewellerydata || null)

        }

    }, [AllData]);




    // console.log(coatItemsdata, "coatItemsdata")


    const firstCoatImage = groomcoatItems[0]?.inventory_category?.inventories?.[0]?.image;
    console.log(Shoesdata?.style, "Shoesdata?.style")

    const { register, handleSubmit, formState: { errors }, control, watch, getValues, trigger, setValue } = useForm({
        defaultValues: {
            firstName: '',
            lastName: '',
            weddingRole: null,
            styletypeChoice: null,
            styleChoice: 'yes',

            GroomMenCoat: coatItemsdata?.style || '',
            GroomMenPant: Pantssdata?.style || '',
            GroomMenShirt: Shirtdata?.style || '',
            GroomMenVest: Vestsdata?.style || '',
            GroomMenTie: Tiesdata?.style || '',
            GroomMenShoe: Shoesdata?.style || '',
            GroomMenPocket: PocketSquaredata?.style || '',
            GroomMenJewelry: Jewellerydata?.style || '',


            GroomMencoatinventory_id: coatItemsdata?.id || null,
            GroomMenjewelryinventory_id: Jewellerydata?.id || null,
            GroomMenpocketinventory_id: PocketSquaredata?.id || null,
            GroomMenshirtinventory_id: Shirtdata?.id || null,
            GroomMenshoeinventory_id: Shoesdata?.id || null,
            GroomMentietinventory_id: Tiesdata?.id || null,
            GroomMenvestinventory_id: Vestsdata?.id || null,
            GroomMenPaintinventory_id: Pantssdata.id || null,

            sameCoat: 'yes',
            samePant: 'yes',
            sameShirt: 'yes',
            sameVest: 'yes',
            sameTie: 'yes',
            sameShoe: 'yes',
            samePocket: 'yes',
            sameJewelry: 'yes'
        }
    });
    const sameCoat = watch("sameCoat");
    const samePant = watch("samePant");
    const sameShirt = watch("sameShirt");
    const sameVest = watch("sameVest");
    const sameTie = watch("sameTie");
    const sameShoe = watch("sameShoe");
    const samePocket = watch("samePocket");
    const sameJewelry = watch("sameJewelry");
    const styleChoice = watch("styleChoice");
    const styletypeChoice = watch("styletypeChoice");
    const firstName = watch("firstName");
    const fetchInventoryDatatwi = async () => {
        try {
            setLoading(true); // Start loading
            const api = `all-inventories?size=${1000}`;
            const response = await get(api);
            if (response?.status == true) {
                setdata(response.data?.rows);
            }
        } catch (err) {
            if (err?.message == "Invalid or expired token" || err?.message == "Invalid Token") {
                localStorage.removeItem('token');
                navigate('/login');
            }
            console.error('Error:', err);
        } finally {
            setLoading(false); // Stop loading regardless of success/error
        }
    };

    useEffect(() => {
        fetchInventoryDatatwi();
    }, []);


    const Viewtype = async () => {
        try {
            const api = `all-wedding-roles`;
            const response = await get(api);
            console.log(response.data)
            if (response?.message == "success") {
                setGettype(response.data);
            }
        } catch (err) {

            console.error('Errordsfdsfd:', err);
        } finally {
            console.log("first")
        }
    };


    const Copytype = async () => {
        try {
            const api = `all-wedding-members-of-event/${Alldata?.id}`;
            const response = await get(api);
            if (response?.status == true) {
                setCopyStyle(response?.data?.rows)
            }
        } catch (err) {

            console.error('Errordsfdsfd:', err);
        } finally {
            console.log("first")
        }
    };
    useEffect(() => {
        if (Alldata) {
            Copytype()

        }
    }, [Alldata])






    console.log(category1Data, "category1Data-------------------------")

    const SelectCopyType = async (selectedId) => {
        try {
            if (selectedId === "aaa") {
                setSelectedCopyStyle({
                    first_name: '',
                    wedding_role: { name: '' },
                });
                const groomsmenStyles = getGroomsmenStyles();
                // setAllData(Alldata); // Reset to original wedding data
                const groomCoat = groomsmenStyles.find(s => s.inventory_category_type === 'Coats')?.inventory_category?.inventories[0];
                const groomPant = groomsmenStyles.find(s => s.inventory_category_type === 'Pants')?.inventory_category?.inventories[0];
                const groomShirt = groomsmenStyles.find(s => s.inventory_category_type === 'Shirt')?.inventory_category?.inventories[0];
                const groomVest = groomsmenStyles.find(s => s.inventory_category_type === 'Vests')?.inventory_category?.inventories[0];
                const groomTie = groomsmenStyles.find(s => s.inventory_category_type === 'Ties')?.inventory_category?.inventories[0];
                const groomShoe = groomsmenStyles.find(s => s.inventory_category_type === 'Shoes')?.inventory_category?.inventories[0];
                const groomPocket = groomsmenStyles.find(s => s.inventory_category_type === 'PocketSquare')?.inventory_category?.inventories[0];
                const groomJewelry = groomsmenStyles.find(s => s.inventory_category_type === 'Jewellery')?.inventory_category?.inventories[0];



                const subRentalCoat = category1Data && category1Data?.some(option => option.style == groomCoat?.style);
                const subRentalPants = pants && pants?.some(option => option.style == groomPant?.style);
                const subRentalShirts = shirts && shirts?.some(option => option.style == groomShirt?.style);
                const subRentalVests = vests && vests?.some(option => option.style == groomVest?.style);
                const subRentalTies = ties && ties?.some(option => option.style == groomTie?.style);
                const subRentalShoes = shoes && shoes?.some(option => option.style == groomShoe?.style);
                const subRentalPockets = pockets && pockets?.some(option => option.style == groomPocket?.style);
                const subRentalJewelries = jewelries && jewelries?.some(option => option.style == groomJewelry?.style);


                if (subRentalCoat && groomCoat) {
                    setValue('GroomMenCoat', groomCoat?.style || '');
                    setValue('GroomMencoatinventory_id', groomCoat?.id || null);
                    setCoatstyle(groomCoat || null);

                }

                if (subRentalPants && groomPant) {
                    setValue('GroomMenPant', groomPant?.style || '');
                    setValue('GroomMenPaintinventory_id', groomPant?.id || null);
                    setPantstyle(groomPant || null);

                }

                if (subRentalShirts && groomShirt) {
                    setValue('GroomMenShirt', groomShirt?.style || '');
                    setValue('GroomMenshirtinventory_id', groomShirt?.id || null);
                    setShirtstyle(groomShirt || null);

                }


                if (subRentalVests && groomVest) {
                    setValue('GroomMenVest', groomVest?.style || '');
                    setValue('GroomMenvestinventory_id', groomVest?.id || null);
                    setVeststyle(groomVest || null);

                }

                if (subRentalTies && groomTie) {
                    setValue('GroomMenTie', groomTie?.style || '');
                    setValue('GroomMentietinventory_id', groomTie?.id || null);
                    setTiestyle(groomTie || null);


                }

                if (subRentalShoes && groomShoe) {
                    setValue('GroomMenShoe', groomShoe?.style || '');
                    setValue('GroomMenshoeinventory_id', groomShoe?.id || null);
                    setShoestyle(groomShoe || null);
                }

                if (subRentalPockets && groomPocket) {
                    setValue('GroomMenPocket', groomPocket?.style || '');
                    setValue('GroomMenpocketinventory_id', groomPocket?.id || null);
                    setPocketstyle(groomPocket || null);
                }

                if (subRentalJewelries && groomJewelry) {
                    setValue('GroomMenJewelry', groomJewelry?.style || '');
                    setValue('GroomMenjewelryinventory_id', groomJewelry?.id || null);
                    setJewelrystyle(groomJewelry || null);
                }

                // Update form values


            } else {
                // Fetch and apply the selected member's styles
                const api = `wedding-member/${selectedId}`;
                const response = await get(api);
                if (response?.status == true) {
                    setAllData(response?.data);

                    const { first_name, wedding_role } = response?.data || {};
                    setSelectedCopyStyle({
                        first_name: first_name || '',
                        wedding_role: wedding_role || {},
                    });
                }
            }
        } catch (err) {
            console.error('Error:', err);
        }
    };



    useEffect(() => {
        Viewtype();
    }, []);




    // Create options for select boxes
    const coatOptions = category1Data?.map(item => ({
        value: item.style,
        label: `${item.style} ${item.description}`,
        data: item
    }));

    const pantOptions = pants?.map(item => ({
        value: item.style,
        label: `${item.style} ${item.description}`,
        data: item
    }));

    const shirtOptions = shirts?.map(item => ({
        value: item.style,
        label: `${item.style} ${item.description}`,
        data: item
    }));

    const vestOptions = vests?.map(item => ({
        value: item.style,
        label: `${item.style} ${item.description}`,
        data: item
    }));

    const tieOptions = ties?.map(item => ({
        value: item.style,
        label: `${item.style} ${item.description}`,
        data: item
    }));

    const shoeOptions = shoes?.map(item => ({
        value: item.style,
        label: `${item.style} ${item.description}`,
        data: item
    }));

    const pocketOptions = pockets?.map(item => ({
        value: item.style,
        label: `${item.style} ${item.description}`,
        data: item
    }));

    const jewelryOptions = jewelries?.map(item => ({
        value: item.style,
        label: `${item.style} ${item.description}`,
        data: item
    }));

    const handleCoatChange = (selectedOption) => {
        if (selectedOption) {
            const selectedStyle = category1Data.find(item => item.style === selectedOption.value);
            console.log(selectedStyle, "selectedStyle")
            const serializedData = JSON.stringify(selectedStyle);
            localStorage.setItem('GroomMencoatStyle', serializedData);
            setValue("GroomMencoatinventory_id", selectedStyle.id);
            setCoatstyle(selectedStyle);
        } else {
            setCoatstyle(null);
            localStorage.removeItem('GroomMencoatStyle');
            setValue("GroomMencoatinventory_id", "");
        }
    };

    const handlePantChange = (selectedOption) => {
        if (selectedOption) {
            const selectedStyle = pants.find(item => item.style === selectedOption.value);
            const serializedData = JSON.stringify(selectedStyle);
            localStorage.setItem('GroomMenpantstyle', serializedData);
            setValue("GroomMenPaintinventory_id", selectedStyle.id);
            setPantstyle(selectedStyle);
        } else {
            setPantstyle(null);
            localStorage.removeItem('GroomMenpantstyle');
            setValue("GroomMenPaintinventory_id", "");
        }
    };

    const handleShirtChange = (selectedOption) => {
        if (selectedOption) {
            const selectedStyle = shirts.find(item => item.style === selectedOption.value);
            const serializedData = JSON.stringify(selectedStyle);
            localStorage.setItem('GroomMenshirtstyle', serializedData);
            setValue("GroomMenshirtinventory_id", selectedStyle.id);
            setShirtstyle(selectedStyle);
        } else {
            setShirtstyle(null);
            localStorage.removeItem('GroomMenshirtstyle');
            setValue("GroomMenshirtinventory_id", "");
        }
    };

    const handleVestChange = (selectedOption) => {
        if (selectedOption) {
            const selectedStyle = vests.find(item => item.style === selectedOption.value);
            const serializedData = JSON.stringify(selectedStyle);
            localStorage.setItem('GroomMenveststyle', serializedData);
            setValue("GroomMenvestinventory_id", selectedStyle.id);
            setVeststyle(selectedStyle);
        } else {
            setVeststyle(null);
            localStorage.removeItem('GroomMenveststyle');
            setValue("GroomMenvestinventory_id", "");
        }
    };

    const handleTieChange = (selectedOption) => {
        if (selectedOption) {
            const selectedStyle = ties.find(item => item.style === selectedOption.value);
            const serializedData = JSON.stringify(selectedStyle);
            localStorage.setItem('GroomMentiestyle', serializedData);
            setValue("GroomMentietinventory_id", selectedStyle.id);
            setTiestyle(selectedStyle);
        } else {
            setTiestyle(null);
            localStorage.removeItem('GroomMentiestyle');
            setValue("GroomMentietinventory_id", "");
        }
    };

    const handleShoeChange = (selectedOption) => {
        if (selectedOption) {
            const selectedStyle = shoes.find(item => item.style === selectedOption.value);
            const serializedData = JSON.stringify(selectedStyle);
            localStorage.setItem('GroomMenshoestyle', serializedData);
            setValue("GroomMenshoeinventory_id", selectedStyle.id);
            setShoestyle(selectedStyle);
        } else {
            setShoestyle(null);
            localStorage.removeItem('GroomMenshoestyle');
            setValue("GroomMenshoeinventory_id", "");
        }
    };

    const handlePocketChange = (selectedOption) => {
        if (selectedOption) {
            const selectedStyle = pockets.find(item => item.style === selectedOption.value);
            const serializedData = JSON.stringify(selectedStyle);
            localStorage.setItem('GroomMenpocketstyle', serializedData);
            setValue("GroomMenpocketinventory_id", selectedStyle.id);
            setPocketstyle(selectedStyle);
        } else {
            setPocketstyle(null);
            localStorage.removeItem('GroomMenpocketstyle');
            setValue("GroomMenpocketinventory_id", "");
        }
    };

    const handleJewelryChange = (selectedOption) => {
        if (selectedOption) {
            const selectedStyle = jewelries.find(item => item.style === selectedOption.value);
            const serializedData = JSON.stringify(selectedStyle);
            localStorage.setItem('GroomMenjewelrystyle', serializedData);
            setValue("GroomMenjewelryinventory_id", selectedStyle.id);
            setJewelrystyle(selectedStyle);
        } else {
            setJewelrystyle(null);
            localStorage.removeItem('GroomMenjewelrystyle');
            setValue("GroomMenjewelryinventory_id", "");
        }
    };


    const onSubmit = async (data) => {
        setIsSubmitting(true)

        const Data = {
            "wedding_id": Alldata.id,
            "first_name": data?.firstName,
            "last_name": data?.lastName,
            member_height: null,
            member_weight: null,
            member_chest: null,
            member_overarm: null,
            wedding_role_id: data?.weddingRole,
            copy_groomsmen_style: data?.styleChoice,
            Rentalterm: "1 week",
            submitted_by: `${profile.firstName} ${profile.lastName}`,
            notes: null,
            status_id: 1,
            // ...(profile?.name == "Admin" && {
            // }),Account, user_Id
            user_id: user_Id || null,
            account: Account.toString(),
            stylesDataForMembers: [
                data?.GroomMenCoat && {
                    type: "groomsman",
                    inventory_category_id: 1,
                    inventory_id: data?.GroomMencoatinventory_id,
                    style: data?.GroomMenCoat,
                    inventory_category_type: "Coats",
                    // member_id: null,
                    size_chart_category_id: null,
                    size_chart_id: null,
                    size: null,
                    insleeve: null
                },

                data?.GroomMenPant && {
                    type: "groomsman",
                    inventory_category_id: 2,
                    inventory_id: data?.GroomMenPaintinventory_id,
                    style: data?.GroomMenPant,
                    // member_id: null,
                    inventory_category_type: "Pants",
                    size_chart_category_id: null,
                    size: null,
                    hip: null,
                    outseam: null
                },

                data?.GroomMenShirt && {
                    type: "groomsman",
                    inventory_category_id: 3,
                    inventory_id: data?.GroomMenshirtinventory_id,
                    style: data?.GroomMenShirt,
                    // member_id: null,
                    inventory_category_type: "Shirt",
                    size_chart_category_id: null,
                    size: null,
                    sleeve: null
                },

                data?.GroomMenVest && {
                    type: "groomsman",
                    inventory_category_id: 4,
                    inventory_id: data?.GroomMenvestinventory_id,
                    style: data?.GroomMenVest,
                    // member_id: null,
                    inventory_category_type: "Vests",

                    size_chart_category_id: null,
                    size: null
                },

                data?.GroomMenTie && {
                    type: "groomsman",
                    inventory_category_id: 5,
                    inventory_id: data?.GroomMentietinventory_id,
                    style: data?.GroomMenTie,
                    // member_id: null,
                    inventory_category_type: "Ties",
                },

                data?.GroomMenPocket && {
                    type: "groomsman",
                    inventory_category_id: 8,
                    inventory_id: data?.GroomMenpocketinventory_id,
                    style: data?.GroomMenPocket,
                    inventory_category_type: "PocketSquare",
                    member_id: null,
                },

                data?.GroomMenJewelry && {
                    type: "groomsman",
                    inventory_category_id: 9,
                    inventory_id: data?.GroomMenjewelryinventory_id,
                    style: data?.GroomMenJewelry,
                    // member_id: null,
                    inventory_category_type: "Jewellery",
                },

                data?.GroomMenShoe && {
                    type: "groomsman",
                    inventory_category_id: 7,
                    inventory_id: data?.GroomMenshoeinventory_id,
                    style: data?.GroomMenShoe,
                    inventory_category_type: "Shoes",
                    // member_id: null,
                    size_chart_id: null,
                    size_chart_category_id: null,
                    size: null
                }

            ].filter(Boolean),
        }


        const api = 'add-wedding-member';

        try {
            const totalData = await post(api, Data);
            console.log(totalData, "totalData");
            navigate(-1)
            toast.success(totalData?.message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                closeButton: false,
            });
            setIsSubmitting(true)

        } catch (error) {
            toast.error(error.message || 'Failed to submit form. Please try again.', {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                closeButton: false,
            });
        }
        console.log(data);
        setIsSubmitting(true)


        // Handle form submission here
    };
    const customComponents = {
        IndicatorSeparator: () => null
    };


    if (loading) {
        return (
            <Container>
                <div className="nk-content">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            <div className="nk-content-body">
                                <Loader /> {/* Your existing Loader component */}
                            </div>
                        </div>
                    </div>
                </div>
            </Container>
        );
    }
    return (
        <Container>
            <div class="nk-content">
                <div class="container-fluid">
                    <div class="nk-content-inner">
                        <div class="nk-content-body">
                            <div class="nk-block-head nk-block-head-sm">
                                <div class="nk-block-between">
                                    <div class="nk-block-head-content">
                                        <h3 class="nk-block-title page-title">Add Member
                                        </h3>
                                    </div>
                                    <div className="">
                                        <span
                                            onClick={() => navigate(-1)}
                                            className="btn btn-outline-light"
                                        >
                                            <em class="icon ni ni-arrow-left"></em> <span> Back</span>
                                        </span>
                                    </div>
                                </div>
                            </div>


                            <div class="card card-full">
                                <div class="card-inner">
                                    <div class="stepperLeft">
                                        <div class="row">
                                            <div class="col-md-4 brIght leftImageCaotUp">
                                                {/* <h5>Wedding Event</h5> */}
                                                <Image src={firstCoatImage ? `${ImageUrl}${firstCoatImage}` : `/assets/images/no-photo.png`} class="w-100 mt-2 mb-3" alt="" />
                                                <div class="groomBrideNameBox">
                                                    <div class="innerGroomBride">
                                                        <GroomLogoIcon />

                                                        <h6 class="mb-0">Groom's Name</h6>
                                                        <p><small>{Alldata?.groom_first_name} {Alldata?.groom_last_name}</small></p>
                                                    </div>

                                                    <div class="innerGroomBride">

                                                        <BrideLogoIcon />

                                                        <h6 class="mb-0">Fiancée's Name</h6>
                                                        <p><small>{Alldata?.bride_first_name} {Alldata?.bride_last_name}</small></p>
                                                    </div>


                                                </div>

                                                <div class="orderEventDate">
                                                    <span>
                                                        <div><em class="icon ni ni-calender-date"></em>Order Submitted:</div>
                                                        <small>{Alldata?.createdAt && moment.utc(Alldata.createdAt).format("MMM D, YYYY")}</small>
                                                    </span>
                                                </div>
                                                <div class="orderEventDate mb-3">
                                                    <span>
                                                        <div><em class="icon ni ni-calender-date"></em> Event Date:</div>
                                                        <small>{Alldata?.wedding_date && moment.utc(Alldata.wedding_date).format("MMM D, YYYY")}</small>
                                                    </span>
                                                </div>

                                            </div>
                                            <div class="col-md-8">
                                                <div class="row groomStyleSizeAddMember">
                                                    <div class="d-flex align-items-center justify-content-between w-100">
                                                        <h5>Groomsman Styles</h5>
                                                    </div>

                                                    <div class="col-md-12">
                                                        <ul class="fstCategory">
                                                            <li><span>Coat:</span> {getStyleAndDescription(groomsmenStyles, 'Coats') || 'N/A'}</li>
                                                            <li><span>Pant:</span> {getStyleAndDescription(groomsmenStyles, 'Pants') || 'N/A'}</li>
                                                            <li><span>Shirt:</span> {getStyleAndDescription(groomsmenStyles, 'Shirt') || 'N/A'}</li>
                                                            <li><span>Vest:</span> {getStyleAndDescription(groomsmenStyles, 'Vests') || 'N/A'}</li>
                                                        </ul>
                                                    </div>
                                                </div>

                                                <hr />

                                                <form onSubmit={handleSubmit(onSubmit)}>
                                                    <div class="inputCardBox mt-4">
                                                        <div className="row">
                                                            <div className="col-6 col-md-6 mb-3 stateSelect">
                                                                <label>First Name <span className="text-red-500">*</span></label>
                                                                <input
                                                                    className={`form-control ${errors.firstName ? 'is-invalid' : ''}`}
                                                                    type="text"
                                                                    placeholder="Enter first name"
                                                                    {...register("firstName", {
                                                                        required: "First name is required",
                                                                        pattern: {
                                                                            value: /^[A-Za-z0-9 ]+$/,
                                                                            message: "Only letters and numbers are allowed"
                                                                        }
                                                                    })}
                                                                />
                                                                {errors.firstName && <div className="invalid-feedback">{errors.firstName.message}</div>}
                                                            </div>

                                                            <div className="col-6 col-md-6 mb-3">
                                                                <label>Last Name <span className="text-red-500">*</span></label>
                                                                <input
                                                                    className={`form-control ${errors.lastName ? 'is-invalid' : ''}`}
                                                                    type="text"
                                                                    placeholder="Enter last name"
                                                                    {...register("lastName", {
                                                                        required: "Last name is required",
                                                                        pattern: {
                                                                            value: /^[A-Za-z0-9 ]+$/,
                                                                            message: "Only letters and numbers are allowed"
                                                                        }
                                                                    })}
                                                                />
                                                                {errors.lastName && <div className="invalid-feedback">{errors.lastName.message}</div>}
                                                            </div>

                                                            <div className="col-6 col-md-6 mb-3">
                                                                <label>Wedding Role <span className="text-red-500"></span></label>
                                                                <select
                                                                    className={`form-control ${errors.weddingRole ? "is-invalid" : ""}`}
                                                                    {...register("weddingRole", { required: "Please select wedding role" })}
                                                                >
                                                                    <option value="">Select</option>
                                                                    {
                                                                        Gettype.map((data) => {
                                                                            return (
                                                                                <>
                                                                                    <option value={data?.id}>{data?.name}</option>
                                                                                </>
                                                                            )
                                                                        })
                                                                    }

                                                                </select>
                                                                {errors.weddingRole && (
                                                                    <div className="invalid-feedback">{errors.weddingRole.message}</div>
                                                                )}
                                                            </div>


                                                            <div className="col-6 col-md-6 mb-3">
                                                                <label>Copy Style<span className="text-red-500"></span></label>
                                                                <Controller
                                                                    name="styletypeChoice"
                                                                    control={control}
                                                                    rules={{ required: "Please select copy style" }}
                                                                    render={({ field }) => (
                                                                        <select
                                                                            {...field}
                                                                            className={`form-control ${errors.styletypeChoice ? "is-invalid" : ""}`}
                                                                            onChange={(e) => {
                                                                                field.onChange(e); // Keep react-hook-form in sync
                                                                                SelectCopyType(e.target.value);
                                                                            }}
                                                                        >
                                                                            <option value="">Select copy style</option>
                                                                            <option value="aaa">Other (Groomsmen Style)</option>
                                                                            {CopyStyle.map((data) => (
                                                                                <option key={data.id} value={data?.id}>
                                                                                    {data?.first_name} / {data?.wedding_role?.name}
                                                                                </option>
                                                                            ))}
                                                                        </select>
                                                                    )}
                                                                />
                                                                {errors.styletypeChoice && (
                                                                    <div className="invalid-feedback">{errors.styletypeChoice.message}</div>
                                                                )}
                                                            </div>


                                                        </div>
                                                        {
                                                            styletypeChoice &&
                                                            <>

                                                                <div className="newAccordion">
                                                                    <div className="accordionContainer">
                                                                        {/* Coat Style */}
                                                                        <AccordionItem
                                                                            id={1}
                                                                            title={
                                                                                coatStyle?.style ? (
                                                                                    <span className="fw-400">
                                                                                        <strong className="fw-700">Coat Style</strong> ({coatStyle?.style} {coatStyle?.description})
                                                                                    </span>
                                                                                ) : (
                                                                                    <span><strong className="fw-700">Coat Style</strong></span>
                                                                                )
                                                                            }
                                                                        >
                                                                            <div className="accordion-inner">
                                                                                <div className="row">
                                                                                    <div className="col-md-8 p-0 stateSelect">
                                                                                        <div className="row">
                                                                                            <div className="col-md-6 mb-3">
                                                                                                <label>Same as {selectedCopyStyle?.wedding_role?.name || "Role"} ({selectedCopyStyle?.first_name || "Name"})<span className="text-red-500"></span></label>
                                                                                                <select className="form-control" {...register("sameCoat")}>
                                                                                                    <option value="yes">Yes</option>
                                                                                                    <option value="No">No</option>
                                                                                                </select>
                                                                                            </div>
                                                                                            {sameCoat == "No" && (
                                                                                                <>
                                                                                                    <div className="col-md-6 mb-3">
                                                                                                        <label>Coat Style<span className="text-red-500">*</span></label>
                                                                                                        <Controller
                                                                                                            name="GroomMenCoat"
                                                                                                            control={control}
                                                                                                            rules={{ required: false }}
                                                                                                            render={({ field }) => (
                                                                                                                <Select
                                                                                                                    {...field}
                                                                                                                    options={coatOptions}
                                                                                                                    placeholder="Select coat style"
                                                                                                                    components={customComponents}
                                                                                                                    isClearable
                                                                                                                    onChange={(selectedOption) => {
                                                                                                                        field.onChange(selectedOption ? selectedOption.value : '');
                                                                                                                        handleCoatChange(selectedOption);
                                                                                                                    }}
                                                                                                                    value={coatOptions?.find(option => option.value === field.value) || null}
                                                                                                                    className={`${errors.GroomMenCoat ? 'is-invalid' : ''}`}
                                                                                                                />
                                                                                                            )}
                                                                                                        />
                                                                                                        {errors.GroomMenCoat && <div className="text-danger small">{errors.GroomMenCoat.message}</div>}
                                                                                                    </div>
                                                                                                    <div className="col-md-12 mb-3">
                                                                                                        {coatStyle && (
                                                                                                            <>
                                                                                                                <h6 className="mb-0 mt-1">#{coatStyle.style}</h6>
                                                                                                                <p className="coatTxtPra"><small>{coatStyle.description}</small></p>
                                                                                                            </>
                                                                                                        )}
                                                                                                    </div>
                                                                                                </>
                                                                                            )}
                                                                                        </div>
                                                                                    </div>
                                                                                    {sameCoat == "No" && (
                                                                                        <div className="col-md-4 addStyleMobileImg">
                                                                                            <Image src={coatStyle?.image ? `${ImageUrl}${coatStyle?.image}` : "assets/images/no-photo.png"} className="selectCoatImg" alt="" />
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        </AccordionItem>

                                                                        {/* Pant */}
                                                                        <AccordionItem
                                                                            id={2}
                                                                            title={
                                                                                pantStyle?.style ? (
                                                                                    <span className="fw-400">
                                                                                        <strong className="fw-700">Pant</strong> ({pantStyle?.style} {pantStyle?.description})
                                                                                    </span>
                                                                                ) : (
                                                                                    <span><strong className="fw-700">Pant</strong></span>
                                                                                )
                                                                            }
                                                                        >
                                                                            <div className="accordion-inner">
                                                                                <div className="row">
                                                                                    <div className="col-md-8 p-0 stateSelect">
                                                                                        <div className="row">
                                                                                            <div className="col-md-6 mb-3">
                                                                                                <label>Same as {selectedCopyStyle?.wedding_role?.name || "Role"} ({selectedCopyStyle?.first_name || "Name"})<span className="text-red-500"></span></label>
                                                                                                <select className="form-control" {...register("samePant")}>
                                                                                                    <option value="yes">Yes</option>
                                                                                                    <option value="No">No</option>
                                                                                                </select>
                                                                                            </div>
                                                                                            {samePant == "No" && (
                                                                                                <>
                                                                                                    <div className="col-md-6 mb-3">
                                                                                                        <label>Select Pant<span className="text-red-500">*</span></label>
                                                                                                        <Controller
                                                                                                            name="GroomMenPant"
                                                                                                            control={control}
                                                                                                            rules={{ required: false }}
                                                                                                            render={({ field }) => (
                                                                                                                <Select
                                                                                                                    {...field}
                                                                                                                    options={pantOptions}
                                                                                                                    placeholder="Select pant style"
                                                                                                                    components={customComponents}
                                                                                                                    isClearable
                                                                                                                    onChange={(selectedOption) => {
                                                                                                                        field.onChange(selectedOption ? selectedOption.value : '');
                                                                                                                        handlePantChange(selectedOption);
                                                                                                                    }}
                                                                                                                    value={pantOptions?.find(option => option.value === field.value) || null}
                                                                                                                    className={`${errors.GroomMenPant ? 'is-invalid' : ''}`}
                                                                                                                />
                                                                                                            )}
                                                                                                        />
                                                                                                        {errors.GroomMenPant && <div className="text-danger small">{errors.GroomMenPant.message}</div>}
                                                                                                    </div>
                                                                                                    <div className="col-md-12 mb-3">
                                                                                                        {pantStyle && (
                                                                                                            <>
                                                                                                                <h6 className="mb-0 mt-1">#{pantStyle.style}</h6>
                                                                                                                <p className="coatTxtPra"><small>{pantStyle.description}</small></p>
                                                                                                            </>
                                                                                                        )}
                                                                                                    </div>
                                                                                                </>
                                                                                            )}
                                                                                        </div>
                                                                                    </div>
                                                                                    {samePant == "No" && (
                                                                                        <div className="col-md-4 addStyleMobileImg">
                                                                                            <Image src={pantStyle?.image ? `${ImageUrl}${pantStyle?.image}` : "assets/images/no-photo.png"} className="selectCoatImg" alt="" />
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        </AccordionItem>

                                                                        {/* Shirt */}
                                                                        <AccordionItem
                                                                            id={3}
                                                                            title={
                                                                                shirtStyle?.style ? (
                                                                                    <span className="fw-400">
                                                                                        <strong className="fw-700">Shirt</strong> ({shirtStyle?.style} {shirtStyle?.description})
                                                                                    </span>
                                                                                ) : (
                                                                                    <span><strong className="fw-700">Shirt</strong></span>
                                                                                )
                                                                            }
                                                                        >
                                                                            <div className="accordion-inner">
                                                                                <div className="row">
                                                                                    <div className="col-md-8 p-0 stateSelect">
                                                                                        <div className="row">
                                                                                            <div className="col-md-6 mb-3">
                                                                                                <label>Same as {selectedCopyStyle?.wedding_role?.name || "Role"} ({selectedCopyStyle?.first_name || "Name"})<span className="text-red-500"></span></label>
                                                                                                <select className="form-control" {...register("sameShirt")}>
                                                                                                    <option value="yes">Yes</option>
                                                                                                    <option value="No">No</option>
                                                                                                </select>
                                                                                            </div>
                                                                                            {sameShirt == "No" && (
                                                                                                <>
                                                                                                    <div className="col-md-6 mb-3">
                                                                                                        <label>Select Shirt<span className="text-red-500">*</span></label>
                                                                                                        <Controller
                                                                                                            name="GroomMenShirt"
                                                                                                            control={control}
                                                                                                            rules={{ required: false }}
                                                                                                            render={({ field }) => (
                                                                                                                <Select
                                                                                                                    {...field}
                                                                                                                    options={shirtOptions}
                                                                                                                    placeholder="Select shirt style"
                                                                                                                    components={customComponents}
                                                                                                                    isClearable
                                                                                                                    onChange={(selectedOption) => {
                                                                                                                        field.onChange(selectedOption ? selectedOption.value : '');
                                                                                                                        handleShirtChange(selectedOption);
                                                                                                                    }}
                                                                                                                    value={shirtOptions?.find(option => option.value === field.value) || null}
                                                                                                                    className={`${errors.GroomMenShirt ? 'is-invalid' : ''}`}
                                                                                                                />
                                                                                                            )}
                                                                                                        />
                                                                                                        {errors.GroomMenShirt && <div className="text-danger small">{errors.GroomMenShirt.message}</div>}
                                                                                                    </div>
                                                                                                    <div className="col-md-12 mb-3">
                                                                                                        {shirtStyle && (
                                                                                                            <>
                                                                                                                <h6 className="mb-0 mt-1">#{shirtStyle.style}</h6>
                                                                                                                <p className="coatTxtPra"><small>{shirtStyle.description}</small></p>
                                                                                                            </>
                                                                                                        )}
                                                                                                    </div>
                                                                                                </>
                                                                                            )}
                                                                                        </div>
                                                                                    </div>
                                                                                    {sameShirt == "No" && (
                                                                                        <div className="col-md-4 addStyleMobileImg">
                                                                                            <Image src={shirtStyle?.image ? `${ImageUrl}${shirtStyle?.image}` : "assets/images/no-photo.png"} className="selectCoatImg" alt="" />
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        </AccordionItem>

                                                                        {/* Vest */}
                                                                        <AccordionItem
                                                                            id={4}
                                                                            title={
                                                                                vestStyle?.style ? (
                                                                                    <span className="fw-400">
                                                                                        <strong className="fw-700">Vest</strong> ({vestStyle?.style} {vestStyle?.description})
                                                                                    </span>
                                                                                ) : (
                                                                                    <span><strong className="fw-700">Vest</strong></span>
                                                                                )
                                                                            }
                                                                        >
                                                                            <div className="accordion-inner">
                                                                                <div className="row">
                                                                                    <div className="col-md-8 p-0 stateSelect">
                                                                                        <div className="row">
                                                                                            <div className="col-md-6 mb-3">
                                                                                                <label>Same as {selectedCopyStyle?.wedding_role?.name || "Role"} ({selectedCopyStyle?.first_name || "Name"})<span className="text-red-500"></span></label>
                                                                                                <select className="form-control" {...register("sameVest")}>
                                                                                                    <option value="yes">Yes</option>
                                                                                                    <option value="No">No</option>
                                                                                                </select>
                                                                                            </div>
                                                                                            {sameVest == "No" && (
                                                                                                <>
                                                                                                    <div className="col-md-6 mb-3">
                                                                                                        <label>Select Vest<span className="text-red-500">*</span></label>
                                                                                                        <Controller
                                                                                                            name="GroomMenVest"
                                                                                                            control={control}
                                                                                                            rules={{ required: false }}
                                                                                                            render={({ field }) => (
                                                                                                                <Select
                                                                                                                    {...field}
                                                                                                                    options={vestOptions}
                                                                                                                    placeholder="Select vest style"
                                                                                                                    components={customComponents}
                                                                                                                    isClearable
                                                                                                                    onChange={(selectedOption) => {
                                                                                                                        field.onChange(selectedOption ? selectedOption.value : '');
                                                                                                                        handleVestChange(selectedOption);
                                                                                                                    }}
                                                                                                                    value={vestOptions?.find(option => option.value === field.value) || null}
                                                                                                                    className={`${errors.GroomMenVest ? 'is-invalid' : ''}`}
                                                                                                                />
                                                                                                            )}
                                                                                                        />
                                                                                                        {errors.GroomMenVest && <div className="text-danger small">{errors.GroomMenVest.message}</div>}
                                                                                                    </div>
                                                                                                    <div className="col-md-12 mb-3">
                                                                                                        {vestStyle && (
                                                                                                            <>
                                                                                                                <h6 className="mb-0 mt-1">#{vestStyle.style}</h6>
                                                                                                                <p className="coatTxtPra"><small>{vestStyle.description}</small></p>
                                                                                                            </>
                                                                                                        )}
                                                                                                    </div>
                                                                                                </>
                                                                                            )}
                                                                                        </div>
                                                                                    </div>
                                                                                    {sameVest == "No" && (
                                                                                        <div className="col-md-4 addStyleMobileImg">
                                                                                            <Image src={vestStyle?.image ? `${ImageUrl}${vestStyle?.image}` : "assets/images/no-photo.png"} className="selectCoatImg" alt="" />
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        </AccordionItem>

                                                                        {/* Tie */}
                                                                        <AccordionItem
                                                                            id={5}
                                                                            title={
                                                                                tieStyle?.style ? (
                                                                                    <span className="fw-400">
                                                                                        <strong className="fw-700">Tie</strong> ({tieStyle?.style} {tieStyle?.description})
                                                                                    </span>
                                                                                ) : (
                                                                                    <span><strong className="fw-700">Tie</strong></span>
                                                                                )
                                                                            }
                                                                        >
                                                                            <div className="accordion-inner">
                                                                                <div className="row">
                                                                                    <div className="col-md-8 p-0 stateSelect">
                                                                                        <div className="row">
                                                                                            <div className="col-md-6 mb-3">
                                                                                                <label>Same as {selectedCopyStyle?.wedding_role?.name || "Role"} ({selectedCopyStyle?.first_name || "Name"})<span className="text-red-500"></span></label>
                                                                                                <select className="form-control" {...register("sameTie")}>
                                                                                                    <option value="yes">Yes</option>
                                                                                                    <option value="No">No</option>
                                                                                                </select>
                                                                                            </div>
                                                                                            {sameTie == "No" && (
                                                                                                <>
                                                                                                    <div className="col-md-6 mb-3">
                                                                                                        <label>Select Tie<span className="text-red-500">*</span></label>
                                                                                                        <Controller
                                                                                                            name="GroomMenTie"
                                                                                                            control={control}
                                                                                                            rules={{ required: false }}
                                                                                                            render={({ field }) => (
                                                                                                                <Select
                                                                                                                    {...field}
                                                                                                                    options={tieOptions}
                                                                                                                    placeholder="Select tie style"
                                                                                                                    components={customComponents}
                                                                                                                    isClearable
                                                                                                                    onChange={(selectedOption) => {
                                                                                                                        field.onChange(selectedOption ? selectedOption.value : '');
                                                                                                                        handleTieChange(selectedOption);
                                                                                                                    }}
                                                                                                                    value={tieOptions?.find(option => option.value === field.value) || null}
                                                                                                                    className={`${errors.GroomMenTie ? 'is-invalid' : ''}`}
                                                                                                                />
                                                                                                            )}
                                                                                                        />
                                                                                                        {errors.GroomMenTie && <div className="text-danger small">{errors.GroomMenTie.message}</div>}
                                                                                                    </div>
                                                                                                    <div className="col-md-12 mb-3">
                                                                                                        {tieStyle && (
                                                                                                            <>
                                                                                                                <h6 className="mb-0 mt-1">#{tieStyle.style}</h6>
                                                                                                                <p className="coatTxtPra"><small>{tieStyle.description}</small></p>
                                                                                                            </>
                                                                                                        )}
                                                                                                    </div>
                                                                                                </>
                                                                                            )}
                                                                                        </div>
                                                                                    </div>
                                                                                    {sameTie == "No" && (
                                                                                        <div className="col-md-4 addStyleMobileImg">
                                                                                            <Image src={tieStyle?.image ? `${ImageUrl}${tieStyle?.image}` : "assets/images/no-photo.png"} className="selectCoatImg" alt="" />
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        </AccordionItem>

                                                                        {/* Shoe */}
                                                                        <AccordionItem
                                                                            id={6}
                                                                            title={
                                                                                shoeStyle?.style ? (
                                                                                    <span className="fw-400">
                                                                                        <strong className="fw-700">Shoe</strong> ({shoeStyle?.style} {shoeStyle?.description})
                                                                                    </span>
                                                                                ) : (
                                                                                    <span><strong className="fw-700">Shoe</strong></span>
                                                                                )
                                                                            }
                                                                        >
                                                                            <div className="accordion-inner">
                                                                                <div className="row">
                                                                                    <div className="col-md-8 p-0 stateSelect">
                                                                                        <div className="row">
                                                                                            <div className="col-md-6 mb-3">
                                                                                                <label>Same as {selectedCopyStyle?.wedding_role?.name || "Role"} ({selectedCopyStyle?.first_name || "Name"})<span className="text-red-500"></span></label>
                                                                                                <select className="form-control" {...register("sameShoe")}>
                                                                                                    <option value="yes">Yes</option>
                                                                                                    <option value="No">No</option>
                                                                                                </select>
                                                                                            </div>
                                                                                            {sameShoe == "No" && (
                                                                                                <>
                                                                                                    <div className="col-md-6 mb-3">
                                                                                                        <label>Select Shoe<span className="text-red-500">*</span></label>
                                                                                                        <Controller
                                                                                                            name="GroomMenShoe"
                                                                                                            control={control}
                                                                                                            rules={{ required: false }}
                                                                                                            render={({ field }) => (
                                                                                                                <Select
                                                                                                                    {...field}
                                                                                                                    options={shoeOptions}
                                                                                                                    placeholder="Select shoe style"
                                                                                                                    components={customComponents}
                                                                                                                    isClearable
                                                                                                                    onChange={(selectedOption) => {
                                                                                                                        field.onChange(selectedOption ? selectedOption.value : '');
                                                                                                                        handleShoeChange(selectedOption);
                                                                                                                    }}
                                                                                                                    value={shoeOptions?.find(option => option.value === field.value) || null}
                                                                                                                    className={`${errors.GroomMenShoe ? 'is-invalid' : ''}`}
                                                                                                                />
                                                                                                            )}
                                                                                                        />
                                                                                                        {errors.GroomMenShoe && <div className="text-danger small">{errors.GroomMenShoe.message}</div>}
                                                                                                    </div>
                                                                                                    <div className="col-md-12 mb-3">
                                                                                                        {shoeStyle && (
                                                                                                            <>
                                                                                                                <h6 className="mb-0 mt-1">#{shoeStyle.style}</h6>
                                                                                                                <p className="coatTxtPra"><small>{shoeStyle.description}</small></p>
                                                                                                            </>
                                                                                                        )}
                                                                                                    </div>
                                                                                                </>
                                                                                            )}
                                                                                        </div>
                                                                                    </div>
                                                                                    {sameShoe == "No" && (
                                                                                        <div className="col-md-4 addStyleMobileImg">
                                                                                            <Image src={shoeStyle?.image ? `${ImageUrl}${shoeStyle?.image}` : "assets/images/no-photo.png"} className="selectCoatImg" alt="" />
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        </AccordionItem>

                                                                        {/* Pocket Square */}
                                                                        <AccordionItem
                                                                            id={7}
                                                                            title={
                                                                                pocketStyle?.style ? (
                                                                                    <span className="fw-400">
                                                                                        <strong className="fw-700">Pocket Square</strong> ({pocketStyle?.style} {pocketStyle?.description})
                                                                                    </span>
                                                                                ) : (
                                                                                    <span><strong className="fw-700">Pocket Square</strong></span>
                                                                                )
                                                                            }
                                                                        >
                                                                            <div className="accordion-inner">
                                                                                <div className="row">
                                                                                    <div className="col-md-8 p-0 stateSelect">
                                                                                        <div className="row">
                                                                                            <div className="col-md-6 mb-3">
                                                                                                <label>Same as {selectedCopyStyle?.wedding_role?.name || "Role"} ({selectedCopyStyle?.first_name || "Name"})<span className="text-red-500"></span></label>
                                                                                                <select className="form-control" {...register("samePocket")}>
                                                                                                    <option value="yes">Yes</option>
                                                                                                    <option value="No">No</option>
                                                                                                </select>
                                                                                            </div>
                                                                                            {samePocket == "No" && (
                                                                                                <>
                                                                                                    <div className="col-md-6 mb-3">
                                                                                                        <label>Select Pocket Square<span className="text-red-500">*</span></label>
                                                                                                        <Controller
                                                                                                            name="GroomMenPocket"
                                                                                                            control={control}
                                                                                                            rules={{ required: false }}
                                                                                                            render={({ field }) => (
                                                                                                                <Select
                                                                                                                    {...field}
                                                                                                                    options={pocketOptions}
                                                                                                                    placeholder="Select pocket square style"
                                                                                                                    components={customComponents}
                                                                                                                    isClearable
                                                                                                                    onChange={(selectedOption) => {
                                                                                                                        field.onChange(selectedOption ? selectedOption.value : '');
                                                                                                                        handlePocketChange(selectedOption);
                                                                                                                    }}
                                                                                                                    value={pocketOptions?.find(option => option.value === field.value) || null}
                                                                                                                    className={`${errors.GroomMenPocket ? 'is-invalid' : ''}`}
                                                                                                                />
                                                                                                            )}
                                                                                                        />
                                                                                                        {errors.GroomMenPocket && <div className="text-danger small">{errors.GroomMenPocket.message}</div>}
                                                                                                    </div>
                                                                                                    <div className="col-md-12 mb-3">
                                                                                                        {pocketStyle && (
                                                                                                            <>
                                                                                                                <h6 className="mb-0 mt-1">#{pocketStyle.style}</h6>
                                                                                                                <p className="coatTxtPra"><small>{pocketStyle.description}</small></p>
                                                                                                            </>
                                                                                                        )}
                                                                                                    </div>
                                                                                                </>
                                                                                            )}
                                                                                        </div>
                                                                                    </div>
                                                                                    {samePocket == "No" && (
                                                                                        <div className="col-md-4 addStyleMobileImg">
                                                                                            <Image src={pocketStyle?.image ? `${ImageUrl}${pocketStyle?.image}` : "assets/images/no-photo.png"} className="selectCoatImg" alt="" />
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        </AccordionItem>

                                                                        {/* Jewelry */}
                                                                        <AccordionItem
                                                                            id={8}
                                                                            title={
                                                                                jewelryStyle?.style ? (
                                                                                    <span className="fw-400">
                                                                                        <strong className="fw-700">Jewelry</strong> ({jewelryStyle?.style} {jewelryStyle?.description})
                                                                                    </span>
                                                                                ) : (
                                                                                    <span><strong className="fw-700">Jewelry</strong></span>
                                                                                )
                                                                            }
                                                                        >
                                                                            <div className="accordion-inner">
                                                                                <div className="row">
                                                                                    <div className="col-md-8 p-0 stateSelect">
                                                                                        <div className="row">
                                                                                            <div className="col-md-6 mb-3">
                                                                                                <label>Same as {selectedCopyStyle?.wedding_role?.name || "Role"} ({selectedCopyStyle?.first_name || "Name"})<span className="text-red-500"></span></label>
                                                                                                <select className="form-control" {...register("sameJewelry")}>
                                                                                                    <option value="yes">Yes</option>
                                                                                                    <option value="No">No</option>
                                                                                                </select>
                                                                                            </div>
                                                                                            {sameJewelry == "No" && (
                                                                                                <>
                                                                                                    <div className="col-md-6 mb-3">
                                                                                                        <label>Select Jewelry<span className="text-red-500">*</span></label>
                                                                                                        <Controller
                                                                                                            name="GroomMenJewelry"
                                                                                                            control={control}
                                                                                                            rules={{ required: false }}
                                                                                                            render={({ field }) => (
                                                                                                                <Select
                                                                                                                    {...field} options={jewelryOptions}
                                                                                                                    placeholder="Select jewelry style"
                                                                                                                    components={customComponents}
                                                                                                                    isClearable
                                                                                                                    onChange={(selectedOption) => {
                                                                                                                        field.onChange(selectedOption ? selectedOption.value : '');
                                                                                                                        handleJewelryChange(selectedOption);
                                                                                                                    }}
                                                                                                                    value={jewelryOptions?.find(option => option.value === field.value) || null}
                                                                                                                    className={`${errors.GroomMenJewelry ? 'is-invalid' : ''}`}
                                                                                                                />
                                                                                                            )}
                                                                                                        />
                                                                                                        {errors.GroomMenJewelry && <div className="text-danger small">{errors.GroomMenJewelry.message}</div>}
                                                                                                    </div>
                                                                                                    <div className="col-md-12 mb-3">
                                                                                                        {jewelryStyle && (
                                                                                                            <>
                                                                                                                <h6 className="mb-0 mt-1">#{jewelryStyle.style}</h6>
                                                                                                                <p className="coatTxtPra"><small>{jewelryStyle.description}</small></p>
                                                                                                            </>
                                                                                                        )}
                                                                                                    </div>
                                                                                                </>
                                                                                            )}
                                                                                        </div>
                                                                                    </div>
                                                                                    {sameJewelry == "No" && (
                                                                                        <div className="col-md-4 addStyleMobileImg">
                                                                                            <Image src={jewelryStyle?.image ? `${ImageUrl}${jewelryStyle?.image}` : "assets/images/no-photo.png"} className="selectCoatImg" alt="" />
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        </AccordionItem>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        }
                                                        <div class="col-md-12 mt-3">
                                                            <button type="submit" className="addBtnCustomer" style={isSubmitting ? { pointerEvents: "none" } : {}}>
                                                                {isSubmitting ? (
                                                                    <>
                                                                        <span class="spinner"></span> Save
                                                                    </>
                                                                ) : (
                                                                    "Save"
                                                                )} </button>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </Container >
    )
}

export default Addmember
